import { useState } from 'react';
import { useLang } from '../../i18n';

const TELEGRAM_URL = 'https://t.me/officialsupport_bet';

const css = `
  .sc-fab { position: fixed; right: 16px; bottom: 84px; z-index: 201; width: 48px; height: 48px; border-radius: 50%;
    background: linear-gradient(135deg, #8187f6, #76e1ff); box-shadow: 0 10px 26px rgba(0,0,0,.5), 0 0 0 6px rgba(118,225,255,.12); display: grid; place-items: center; border: none; cursor: pointer; }
  .sc-fab svg { display: block; }
  .sc-fab .sc-ping { position: absolute; top: -2px; right: -2px; width: 13px; height: 13px; border-radius: 50%; background: #76e1ff; box-shadow: 0 0 0 2px #100e26; }
  .sc-root { position: fixed; inset: 0; z-index: 202; }
  .sc-backdrop { position: absolute; inset: 0; background: rgba(2,1,15,.55); }
  .sc-sheet { position: absolute; left: 0; right: 0; bottom: 0; height: 82%; border-radius: 16px 16px 0 0;
    display: flex; flex-direction: column; overflow: hidden; transform: translateY(0); animation: sc-up .26s ease both; background: #100e26; }
  @keyframes sc-up { from { transform: translateY(100%); } to { transform: translateY(0); } }
  .sc-head { display: flex; align-items: center; gap: 11px; padding: 13px 14px; background: #16142e; box-shadow: inset 0 -1px 0 rgba(255,255,255,.06); }
  .sc-ava { width: 34px; height: 34px; border-radius: 10px; background: #1d1c3c; display: grid; place-items: center; position: relative; flex: none; overflow: visible; }
  .sc-ava .dot { position: absolute; right: -2px; bottom: -2px; width: 10px; height: 10px; border-radius: 50%; background: #76e1ff; box-shadow: 0 0 0 2px #16142e; }
  .sc-logo { width: 100%; height: 100%; object-fit: cover; border-radius: inherit; display: block; }
  .sc-htitle { font-size: 15px; font-weight: 800; color: #fff; line-height: 1.1; }
  .sc-status { font-size: 12px; color: #76e1ff; font-weight: 700; }
  .sc-close { margin-left: auto; width: 32px; height: 32px; border-radius: 9px; background: rgba(255,255,255,.1); display: grid; place-items: center; }
  .sc-body { flex: 1; overflow-y: auto; padding: 16px 14px; display: flex; flex-direction: column; gap: 12px; }
  .sc-msg { display: flex; gap: 8px; max-width: 88%; }
  .sc-msg.support { align-self: flex-start; }
  .sc-mava { width: 26px; height: 26px; border-radius: 8px; background: #1d1c3c; display: grid; place-items: center; flex: none; overflow: hidden; }
  .sc-bubble { background: #1d1c3c; border-radius: 11px; padding: 9px 12px; }
  .sc-text { font-size: 13px; color: #fff; line-height: 1.45; }
  .sc-tg-link { color: #76e1ff; font-weight: 800; text-decoration: none; }
  .sc-tg-link:hover { text-decoration: underline; }
  .sc-tg-btn { display: inline-flex; align-items: center; gap: 8px; align-self: flex-start; margin-left: 34px; height: 42px; padding: 0 18px; border-radius: 21px;
    background: linear-gradient(135deg, #8187f6, #76e1ff); color: #fff; font-size: 13px; font-weight: 700; text-decoration: none; box-shadow: 0 6px 18px rgba(118,225,255,.22); }
  .sc-tg-btn svg { display: block; }
  @media (min-width: 1023px) {
    .sc-fab { bottom: 28px; right: 28px; }
    .sc-sheet { left: auto; right: 28px; bottom: 28px; width: 370px; height: 540px; border-radius: 16px; animation: sc-pop .22s ease both; }
    @keyframes sc-pop { from { opacity: 0; transform: scale(.94) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
  }
`;

export default function SupportChat() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <>
      <style>{css}</style>
      {!open && (
        <button className="sc-fab" onClick={() => setOpen(true)} aria-label="Support">
          <span className="sc-ping" />
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 4c4.4 0 8 2.9 8 6.5S16.4 17 12 17c-.9 0-1.8-.1-2.6-.3L5 18l1-3.1C4.4 13.7 4 12.2 4 10.5 4 6.9 7.6 4 12 4z" fill="#fff" />
            <circle cx="9" cy="10.5" r="1.1" fill="#8187f6" />
            <circle cx="12" cy="10.5" r="1.1" fill="#8187f6" />
            <circle cx="15" cy="10.5" r="1.1" fill="#8187f6" />
          </svg>
        </button>
      )}
      {open && (
        <div className="sc-root">
          <div className="sc-backdrop" onClick={() => setOpen(false)} />
          <div className="sc-sheet">
            <div className="sc-head">
              <span className="sc-ava"><img className="sc-logo" src="/carre.png" alt="Roxs Sports" /><span className="dot" /></span>
              <span>
                <div className="sc-htitle">{t('support.title')}</div>
                <div className="sc-status">{t('support.online')}</div>
              </span>
              <button className="sc-close" onClick={() => setOpen(false)} aria-label="Close">
                <svg width="13" height="13" viewBox="0 0 13 13">
                  <path d="M2 2l9 9M11 2L2 11" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <div className="sc-body">
              <div className="sc-msg support">
                <span className="sc-mava"><img className="sc-logo" src="/carre.png" alt="" /></span>
                <div className="sc-bubble">
                  <div className="sc-text">
                    {t('support.noAgent')}{' '}
                    <a className="sc-tg-link" href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer">@officialsupport_bet</a>.
                  </div>
                </div>
              </div>
              <a className="sc-tg-btn" href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M21 4L3 11l5 2 2 6 3-4 5 3z" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
                </svg>
                t.me/officialsupport_bet
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
